<div id="errors-output" role="alert" *ngIf="errorsModel">
	<div class="row">
		<div class="col col-12 text-center">
			<a mat-link-button color="warn" href="{{errorsModel.informationLink}}">{{errorsModel.message}}</a>
		</div>
	</div>
	<div class="row">
		<div class="col col-6">
		</div>
		<div class="col col-6">
		</div>
	</div>
</div>
<div style="margin-bottom: 10px;">
	<form action="/token" id="my-sample-form" method="post">
		<div class="form-group">
			<div style="margin-bottom: 10px;">
				<div class="h5">Card Info</div>
				<div class="form-row">
					<div class="form-group col col-12">
						<label type="text" id="cardholderName-label" name="CardholderName" matTooltip={{cardholderNameError}}>Name</label>
						<input id="cardholderName" class="form-control" name="cardholderName" placeholder="Name on the card"  [(ngModel)]="cardholderName" onfocus="checkBoA();">
					</div>
				</div>
				<div class="form-row">
					<div class="form-group col col-12">
						<label id="number-label" matTooltip={{cardNumberError}}>Card Number</label>
						<div id="number-container" class="form-control" onfocus="checkBoA();"></div>
					</div>
				</div>
				<div class="form-row">
					<div class="form-group col col-12">
						<label id="securityCode-label" for="securityCode-container" matTooltip={{securityCodeError}}>Security Code</label>
						<div id="securityCode-container" class="form-control" onfocus="checkBoA();"></div>
					</div>
				</div>
				<div class="form-row">
					<div class="form-group col-md-6">
						<label id="expirationMonth-label" for="expMonth" matTooltip={{expiryMonthError}}>Expiry Month</label>
						<select id="expMonth" class="form-control" name="ExpiryMonth" [(ngModel)]="expiryMonth" onfocus="checkBoA();">
							<option></option>
							<option value="01">Jan</option>
							<option value="02">Feb</option>
							<option value="03">Mar</option>
							<option value="04">Apr</option>
							<option value="05">May</option>
							<option value="06">Jun</option>
							<option value="07">Jul</option>
							<option value="08">Aug</option>
							<option value="09">Sep</option>
							<option value="10">Oct</option>
							<option value="11">Nov</option>
							<option value="12">Dec</option>
						</select>
					</div>
					<div class="form-group col-md-6">
						<label id="expirationYear-label" for="expYear" matTooltip={{expiryYearError}}>Expiry Year</label>
						<select id="expYear" class="form-control" name="ExpYear" [(ngModel)]="expiryYear" onfocus="checkBoA();">
							<option value="{{yr}}" *ngFor="let yr of years">{{yr}}</option>
						</select>
					</div>
				</div>
			</div>
			<div *ngIf="showBilling !== undefined && showBilling != null">
				<div style="margin-bottom: 10px;">
					<div class="h5">Contact Info</div>
					<div class="form-row">
						<div class="form-group col col-12">
							<label type="text" id="emailAddress-label" name="EmailAddressLabel" matTooltip={{emailAddressError}}>Email Address</label>
							<input id="emailAddress" class="form-control" name="emailAddress" placeholder="user@domain.tld"  [(ngModel)]="emailAddress" onfocus="checkBoA();">
						</div>
					</div>
				</div>
				<div style="margin-bottom: 10px;">
					<div class="h5">Billing Info</div>
					<div class="form-row">
						<div class="form-group col col-12">
							<label type="text" id="address1-label" name="Address1Label" matTooltip={{address1Error}}>Street Address</label>
							<input id="address1" class="form-control" name="Address1" placeholder="Street Address"  [(ngModel)]="address1" onfocus="checkBoA();">
						</div>
					</div>
					<div class="form-row">
						<div class="form-group col col-12">
							<label type="text" id="locality-label" name="LocalityLabel" matTooltip={{localityError}}>Locality</label>
							<input id="locality" class="form-control" name="Locality" placeholder="(e.g. Beverly Hills)"  [(ngModel)]="locality" onfocus="checkBoA();">
						</div>
					</div>
					<div class="form-row">
						<div class="form-group col col-md-6">
							<label type="text" id="region-label" name="RegionLabel" matTooltip={{regionError}}>State or Province</label>
							<select id="region" class="form-control" name="Region" placeholder="(e.g. CA)"  [(ngModel)]="region" onfocus="checkBoA();">
								<option value="{{rg.abbreviation}}" *ngFor="let rg of regionsList">{{rg.regionName}}</option>
							</select>
						</div>
						<div class="form-group col col-md-6">
							<label type="text" id="country-label" name="CountryLabel" matTooltip={{countryError}}>Country</label>
							<select id="country" class="form-control" name="Country" placeholder="(e.g. US)"  [(ngModel)]="country" onfocus="checkBoA();">
								<option value="{{ct.abbreviation}}" *ngFor="let ct of countriesList">{{ct.countryName}}</option>
							</select>
						</div>
					</div>
					<div class="form-row">
						<div class="form-group col col-12">
							<label type="text" id="postalCode-label" name="PostalCodeLabel" matTooltip={{postalCodeError}}>Zip or Postal Code</label>
							<input id="postalCode" class="form-control" name="PostalCode" placeholder="(e.g. 90210)"  [(ngModel)]="postalCode" onfocus="checkBoA();">
						</div>
					</div>
					<div class="form-row">
						<div class="form-group col col-12">
							<label type="text" id="phoneNumber-label" name="PhoneNumberLabel" matTooltip={{phoneNumberError}}>Phone Number</label>
							<input id="phoneNumber" class="form-control" name="PhoneNumber" placeholder="(e.g. 555-555-5555)"  [(ngModel)]="phoneNumber" onfocus="checkBoA();">
						</div>
					</div>
				</div>
			</div>
			<div style="margin-bottom: 10px;">
				<button mat-raised-button type="button" id="pay-button" class="btn btn-primary" [ngClass]="{ disabled: loading }" (click)="submitPayment()" [disabled]="loading">Pay</button>
				<input type="hidden" id="flexresponse" name="flexresponse">
			</div>
		</div>
	</form>
</div>
<input type="hidden" id="errorResponse" on-change="handleBoAResponseEvent(errorResponse.value, true)" (click)="handleBoAResponseEvent(errorResponse.value, true);" #errorResponse/>
<input type="hidden" id="tokenResponse" on-change="handleBoAResponseEvent(tokenResponse.value, false)" (click)="handleBoAResponseEvent(tokenResponse.value, false);" #tokenResponse/>
<div id="elemScript"></div>
<div id="elemSetup"></div>
<div id="elemSubmit"></div>